export default "__VITE_ASSET__IyJcPB0V__"